import * as React from 'react';
import * as _ from 'lodash';
import { PARTS } from './../../../schemas/accessRightsModel';
import { Combobox } from 'react-input-enhancements';
import { Dropdown } from 'react-input-enhancements';
import { UIDropDown } from '../../Generic/dropDown';
import CheckBox from '../../PageLayout/CheckBox';
import { getSizedThumbnailUrl } from './../../../utilities/helpers';
export default function (props, context) {
    function onClick1(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleVisibilityClick({});
    }
    function onClick2(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleVisibilityClick(e, 'kv');
    }
    function onClick3(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleVisibilityClick(e, 'bv');
    }
    function onClick4(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleVisibilityClick(e, 'qt');
    }
    function onChecked5(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV) {
        {
            this.toggleForVisualizer('kv');
        }
    }
    function onChecked6(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV) {
        {
            this.toggleForVisualizer('bv');
        }
    }
    function onChecked7(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV) {
        {
            this.handleChangeEvent('forQuotingTool', !this.state.forQuotingTool);
        }
    }
    function onChange8(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleChangeEvent('price', e.target.value);
    }
    function onRenderList9(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, className, style, isActive, listShown, children) {
        return listShown && isActive ? React.createElement('div', {
            'className': 'lightbox-drop-down-menu',
            'style': { position: 'relative' },
            'key': '3743'
        }, '\r\n            ', children, '\r\n          ') : null;
    }
    function onRenderOption10(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, className, style, option, highlighted) {
        return React.createElement('div', { 'className': 'lightbox-drop-down-lir ' + (highlighted ? 'lightbox-drop-down-lir-highlight' : '') }, '\r\n            ', option && option.value || option, '\r\n          ');
    }
    function onRenderCaret11(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV) {
        return React.createElement('div', {});
    }
    function onChange12(installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV, e) {
        this.handleChangeEvent('name', e.target.value);
    }
    function scopeInstallationEnabledCanEditDisabledBorderClassImageStyleStyleClassLoaderClassEnabledForQTForVisualizersEnabledForKVEnabledForBV13() {
        var installation = this.props.updatedInstallation;
        var enabled = installation.forQuotingTool || installation.forVisualizers.split(',').length > 0;
        var canEdit = this.props.canEdit;
        var disabledBorderClass = enabled ? '' : 'disabled';
        var imageStyle = 'rectangular';
        var styleClass = `lightbox-option-${ imageStyle }`;
        var loaderClass = `lightbox-option-${ imageStyle }-loader`;
        var enabledForQT = this.state.forQuotingTool;
        var forVisualizers = this.state.forVisualizers || '';
        var enabledForKV = forVisualizers.includes('kv');
        var enabledForBV = forVisualizers.includes('bv');
        return React.createElement('div', { 'className': 'lightbox-flex-item' }, React.createElement('div', { 'className': styleClass + ' ' + (!enabled ? `${ styleClass }-disabled` : '') }, React.createElement('div', {
            'className': 'pj-scope-feature-status-group',
            'onClick': onClick1.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV),
            'title': canEdit ? 'CTRL+Click to quick-toggle visibility on/off (CMD+Click on Mac)' : ''
        }, React.createElement('div', {
            'className': 'pj-scope-feature-status-group-item ' + (enabledForKV ? 'on' : ''),
            'onClick': onClick2.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }, 'KV'), React.createElement('div', {
            'className': 'pj-scope-feature-status-group-item ' + (enabledForBV ? 'on' : ''),
            'onClick': onClick3.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }, 'BV'), React.createElement('div', {
            'className': 'pj-scope-feature-status-group-item ' + (enabledForQT ? 'on' : ''),
            'onClick': onClick4.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }, 'QT'), React.createElement('div', { 'className': 'pj-scope-feature-status-group-items-container ' + (this.state.showingVisibility ? '' : 'hide') }, React.createElement('div', { 'className': 'pj-scope-feature-status-group-items-container-inner' }, React.createElement(CheckBox, {
            'checked': this.forVisualizer('kv'),
            'border': true,
            'text': 'Kitchen',
            'onChecked': onChecked5.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }), React.createElement(CheckBox, {
            'checked': this.forVisualizer('bv'),
            'border': true,
            'text': 'Bathroom',
            'onChecked': onChecked6.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }), React.createElement(CheckBox, {
            'checked': this.state.forQuotingTool,
            'border': true,
            'text': 'Quoting',
            'onChecked': onChecked7.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        })))), React.createElement('div', {
            'className': 'lightbox-edit-icon lightbox-edit-icon-circle',
            'onClick': this.handleEditClick
        }), React.createElement('div', {
            'className': loaderClass + ' ' + `rectangular-edge` + ' ' + (!enabled ? `rectangular-desaturate` : ''),
            'style': { backgroundImage: 'url(\'' + getSizedThumbnailUrl(installation.thumbnailImageUrl, 150) + '\')' }
        }), React.createElement('div', { 'className': 'lightbox-input-container' }, React.createElement('div', { 'className': 'lightbox-input-dashed-outline' }), React.createElement('input', {
            'readOnly': !canEdit,
            'className': 'lightbox-input ' + disabledBorderClass,
            'placeholder': 'Enter Price',
            'value': this.state.price,
            'onChange': onChange8.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV),
            'maxLength': '10'
        }), React.createElement(Dropdown, {
            'disabled': !canEdit,
            'value': this.state.unit.unit,
            'options': this.getUnitOptions(),
            'className': 'lightbox-unit-dropdown-wrapper ' + disabledBorderClass,
            'dropdownProps': { style: { position: 'static' } },
            'onValueChange': this.onChangeUnit,
            'onRenderList': onRenderList9.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV),
            'onRenderOption': onRenderOption10.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV),
            'onRenderCaret': onRenderCaret11.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV)
        }, React.createElement('input', {
            'className': 'lightbox-unit-dropdown ' + (!enabled || !canEdit ? 'lightbox-unit-dropdown-disabled' : ''),
            'type': 'button'
        }))), React.createElement('div', { 'className': 'lightbox-description-frame' }, React.createElement('div', { 'className': 'lightbox-description-text-outline' }), React.createElement('input', {
            'className': 'lightbox-description-text',
            'placeholder': 'Enter Name',
            'value': this.state.name,
            'onChange': onChange12.bind(this, installation, enabled, canEdit, disabledBorderClass, imageStyle, styleClass, loaderClass, enabledForQT, forVisualizers, enabledForKV, enabledForBV),
            'readOnly': !canEdit,
            'maxLength': '64'
        }))));
    }
    return scopeInstallationEnabledCanEditDisabledBorderClassImageStyleStyleClassLoaderClassEnabledForQTForVisualizersEnabledForKVEnabledForBV13.apply(this, []);
}